import {
  GRADE_K2_TIERED_INTERVENTIONS,
  GRADE_35_TIERED_INTERVENTIONS,
  GRADE_68_TIERED_INTERVENTIONS,
} from '../program/types'

// TODO: update this to have the properDWB once courses are wired up in Contentful.
const createDigitalWellBeingGradeMapping = ({ courseName, displayTitle }) => ({
  courseName,
  displayTitle,
  slug: `grade-${courseName}`,
  internalTitle: `${displayTitle}, DwbDigital`,
  id: '',
  defaultLessonSlug: 'unit-1',
  shouldShowOnLessonsPage: true,
})

const DWB_COURSE_NAMES = [
  'k',
  ...Array.from({ length: 12 }, (_, i) => String(i + 1)),
]

const getDwbDisplayTitle = courseName =>
  courseName === 'k' ? 'Grade K' : `Grade ${courseName}`

// Preview/teach paths use /lessons/:verb/grade-:n/:unit (e.g. grade-k, grade-6).
export const digitalWellBeingV2ContentfulMappings = DWB_COURSE_NAMES.map(
  courseName =>
    createDigitalWellBeingGradeMapping({
      courseName,
      displayTitle: getDwbDisplayTitle(courseName),
    }),
)

const createGradeContentfulMapping = ({
  courseName,
  displayTitle,
  internalTitle,
  id,
  defaultLessonSlug,
  defaultUnit,
  shouldShowOnLessonsPage,
}) => ({
  courseName,
  displayTitle,
  internalTitle,
  id,
  ...(defaultUnit
    ? { defaultUnit }
    : { defaultLessonSlug: defaultLessonSlug ?? 'unit-1' }),
  shouldShowOnLessonsPage,
})

const ELEMENTARY_GRADE_DATA = [
  {
    courseName: 'k',
    displayTitle: 'Grade K',
    internalTitle: 'Grade K, ElemDigital ',
    id: '6IfdgJVUG6IpK1QXeMPiNU',
  },
  {
    courseName: '1',
    displayTitle: 'Grade 1',
    internalTitle: 'Grade 1, ElemDigital',
    id: '3CEV7ZzA2kUwg9o3jVbZPb',
  },
  {
    courseName: '2',
    displayTitle: 'Grade 2',
    internalTitle: 'Grade 2, ElemDigital',
    id: '7mXOmpE9MjFyXtSz1zyIhF',
  },
  {
    courseName: '3',
    displayTitle: 'Grade 3',
    internalTitle: 'Grade 3, ElemDigital',
    id: '2uAtX2IqOvTJuERHUhyupL',
  },
  {
    courseName: '4',
    displayTitle: 'Grade 4',
    internalTitle: 'Grade 4, ElemDigital',
    id: '5bJhDzZQUU2GahVcCsYPRa',
  },
  {
    courseName: '5',
    displayTitle: 'Grade 5',
    internalTitle: 'Grade 5, ElemDigital',
    id: '2z9CNsFLrmLSd11uM9KpDk',
  },
]

const ELEMENTARY_TIER_DATA = [
  {
    courseName: GRADE_K2_TIERED_INTERVENTIONS,
    displayTitle: 'Grade K-2',
    internalTitle: 'grade k-2 course - k8 tier2 - root',
    id: '6T2703qI3n8KaHvLYR8X1W',
    defaultUnit: 'emotions-thoughts-feelings',
    shouldShowOnLessonsPage: false,
  },
  {
    courseName: GRADE_35_TIERED_INTERVENTIONS,
    displayTitle: 'Grade 3-5',
    internalTitle: 'grade 3-5 course - k8 tier2 - root',
    id: '7091GjQgPmg4WE64S04sej',
    defaultUnit: 'emotions-thoughts-feelings',
    shouldShowOnLessonsPage: false,
  },
]

const MIDDLE_SCHOOL_GRADE_DATA = [
  {
    courseName: '6',
    displayTitle: 'Grade 6',
    internalTitle: 'Grade 6, MSdigital',
    id: '3MGuMC1rZH4HDF3MNKj3b4',
  },
  {
    courseName: '7',
    displayTitle: 'Grade 7',
    internalTitle: 'Grade 7, MSdigital',
    id: '1k9vPryVAuk0XG4pU9IwnI',
  },
  {
    courseName: '8',
    displayTitle: 'Grade 8',
    internalTitle: 'Grade 8, MSdigital',
    id: '5mhIMAgQUP2RgAxfC3ucyD',
  },
]

const MIDDLE_SCHOOL_TIER_DATA = [
  {
    courseName: GRADE_68_TIERED_INTERVENTIONS,
    displayTitle: 'Grade 6-8',
    internalTitle: 'grade 6-8 course - k8 tier2 - root',
    id: '6zJmyzNhKbMQRj2rhd8lM7',
    defaultUnit: 'emotions-thoughts-feelings',
    shouldShowOnLessonsPage: false,
  },
]

export const elementaryV2ContentfulMappings = [
  ...ELEMENTARY_GRADE_DATA.map(grade =>
    createGradeContentfulMapping({
      ...grade,
      shouldShowOnLessonsPage: true,
    }),
  ),
  ...ELEMENTARY_TIER_DATA.map(tier => createGradeContentfulMapping(tier)),
]

// TODO: This is a mapping for the new Contentful ids for Middle School and is a hack to override old Contentful Ids until Program Flex is fully implemented
// defaultLessonSlug: first DWB preview unit path segment; passed through getCourseLinks.
export const middleSchoolV2ContentfulMappings = [
  ...MIDDLE_SCHOOL_GRADE_DATA.map(grade =>
    createGradeContentfulMapping({
      ...grade,
      shouldShowOnLessonsPage: true,
    }),
  ),
  ...MIDDLE_SCHOOL_TIER_DATA.map(tier => createGradeContentfulMapping(tier)),
]

export const k8V2ContentfulMappings = [
  ...elementaryV2ContentfulMappings,
  ...middleSchoolV2ContentfulMappings,
]
